export const safeReplace = (string: string, ...args: [string, string]): string => string && string.replace(...args);

export const safeLowerCase = (string: string) => string && string.toLowerCase();

export const safeUpperCase = (string: string) => string && string.toUpperCase();

export const escapeString = (string: string) => string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

export const decodeHTML = (html: string): string => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

interface IStringToLispCase {
  string: string;
  prefix?: string;
  suffix?: string;
}

export const stringToLispCase = ({ string, prefix = '', suffix = '' }: IStringToLispCase) =>
  string && `${prefix.trim()}${string.trim().replaceAll(' ', '-').toLowerCase()}${suffix.trim()}`;

export const uppercaseFirstLetter = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

export const toTitleCase = (text: string, separator: string = ' ') =>
  text
    .toLowerCase()
    .split(separator)
    .map((word: string) => uppercaseFirstLetter(word).replace(/(^|\/|-|')(\S)/g, (s) => s.toUpperCase()))
    .join(separator);

type StringCase = 'LOWERCASE' | 'UPPERCASE' | 'TITLECASE';

export const changeTextCase = (text: string, toTextCase: StringCase, force: boolean = false): string => {
  switch (toTextCase) {
    case 'LOWERCASE':
      return text.toLowerCase();
    case 'UPPERCASE':
      return text.toUpperCase();
    default: {
      // Count UPPERCASE and LOWERCASE characters
      const lengthUpperCase: number = (text.match(/[A-Z]/g) || []).length;
      const lengthLowerCase: number = (text.match(/[a-z]/g) || []).length;
      const fromTextCase: StringCase =
        // eslint-disable-next-line no-nested-ternary
        lengthUpperCase > 0 && lengthLowerCase === 0
          ? 'UPPERCASE'
          : lengthUpperCase === 0 && lengthLowerCase > 0
          ? 'LOWERCASE'
          : 'TITLECASE';
      return fromTextCase === 'TITLECASE' && !force ? text : toTitleCase(text); // To return "Val d'Aosta" and not "Val D'Aosta"
    }
  }
};
